import { fromJS, List, Map } from 'immutable'
import { REHYDRATE } from 'redux-persist'
// @ts-ignore
import { get } from 'lodash'

import * as types from './actionTypes'
import { CountriesCodes, OneSignal, Organization } from 'store/records/organization'
// @ts-ignore
import { User } from 'store/records/user'
// @ts-ignore
import { PER_PAGE } from 'app/constants/pagination'
// @ts-ignore
import { getIdentityProgress } from 'store/entities/identity/actions'
import {
  createOneSignalApplication,
  deleteOrganizationUser,
  deleteOrganizationUserRole,
  deleteSprintById,
  fetchAllOrganizationUsers,
  fetchAvailableProTrackLevelsForSelectedOrg,
  fetchIdRequest,
  fetchOrganizationById,
  fetchOrganizationProtrackLevelChanges,
  fetchSprintById,
  fetchSwitchProTrackLevelsHistory,
  fetchUsers,
  fetchUsersByStatus,
  filterUsersByForAdmin,
  getUserProtrackActivities,
  getUserProtracks,
  postPartnersLinks,
  setOrganizationUsersFilter,
  setReviewsSurveyId,
  toggleOrganizationSprints,
  updateOrganization,
  updateOrganizationProtrackLevelTeams,
  updateOrganizationProtrackLevelTeamsSuccessForMicroactions,
  updateUserEmail,
  updateUserEmailForReviews,
  updateUserNotificationTypes,
  updateUserPhoneNumber,
  updateUserProtrackActivity,
  updateUserTeams,
  updateUserTeamsSuccessForMicroactions,
  updateUserTeamsSuccessForReviews,
  deleteOrganizationUserBulkForMicroactionTable,
  createOrganization,
  deleteOrganization,
  switchOrganizationsUsersSuccess,
  fetchUsersForCSV,
  setApiKeyAndEmailFrom,
  updateApiKeyAndEmailFrom,
  clearCacheOrganizationUsers,
  fetchOrganizationTeams,
} from 'store/entities/organizations/actions'
import { getProTrackOrganizationUsersEmails } from 'store/entities/protracks/actions'
// @ts-ignore
import { USERS_FILTER, USERS_TEAM_FILTER } from 'app/constants/organizations'
// @ts-ignore
import { mapCountriesCodes } from 'helpers/parsePhone'
import { IFormState, IOrganizationInitialState } from './interfaces/reducer.interfaces'
import { IAction } from './interfaces/action.interfaces'
import { isUserOnPageExist } from 'helpers/isUserOnPageExist'
import { exportUsersAsCSV } from 'helpers/getUserUIData'

export const invitesState = fromJS({
  organization: new Organization(),
})

export const usersState = fromJS({
  all: {},
  cachedTime: null,
  pagination: {
    current: 0,
    perPage: PER_PAGE,
    count: 0,
    totalPages: 0,
  },
  sort: {
    by: null,
    desc: false,
  },
  filter: '',
  tab: 'users',
  selectedOrganizationId: null,
  selectedOrganizationName: '',
  selectedOrganization: {
    proTrackLevels: [],
    historySwitchProTrackLevels: [],
  },
  isUsersTeamCanBeRemoved: false,
  pending: false,
  loaded: false,
  protracks: [],
  view: null,
  usersFilter: USERS_FILTER.ALL,
  filterByTeam: USERS_TEAM_FILTER.ALL,
  user: {
    activities: [],
    protracks: [],
    resendNotificationStatus: {
      morning: {
        isAvailable: false,
        resendCount: 0,
        resendBy: '',
      },
      evening: {
        isAvailable: false,
        resendCount: 0,
        resendBy: '',
      },
    },
    view: null,
    languages: null,
  },
  countByStatus: {},
  usersOnPage: {},
  filterForAdmin: '',
}) as object

export const formState: IFormState = {
  type: null,
  disabled: false,
}

export const initialStateJS: IOrganizationInitialState = {
  all: {},
  view: {},
  pagination: {
    current: 0,
    perPage: PER_PAGE,
  },
  sort: {
    by: null,
    desc: false,
  },
  filter: '',
  users: usersState,
  invites: invitesState,
  form: formState,
  isPending: {
    getOrganizationUsers: false,
    sprint: false,
    getOrganizationById: false,
  },
  pendingObject: {}, // pendingObject for save temporary data
  viewOrganizationSettings: {
    entity: new Organization(),
    loaded: false,
  },
  usedLevelsIds: [],
  hasActiveUsersLevelsIds: [],
  languages: {
    en: {
      isReferenceLanguage: true,
      name: 'English',
      nativeName: 'English',
      translated: {
        latest: 1,
      },
      latest: 1,
    },
  },
  microActionLevelUsersList: [],
}

export const initialState = fromJS(initialStateJS)

export default function (state: any = initialState, action: IAction) {
  const { type, payload } = action

  switch (type) {
    case REHYDRATE:
      return payload && payload.organizations && payload.organizations.set
        ? payload.organizations.setIn(['pending', 'getOrganizationUsers'], false)
        : state
    case types.ORGANIZATIONS_FETCH_ALL_SUCCESS:
      const organizations = payload.data
      const newState = state.set(
        'all',
        organizations.reduce((acc: Map<number, Organization>, organization: Organization) => {
          // @ts-ignore
          organization.countriesCodes = mapCountriesCodes(organization.countriesCodes)
          // @ts-ignore
          return acc.set(organization.id.toString(), new Organization(fromJS(organization)).prepare())
        }, Map())
      )
      if (!state.getIn(['users', 'selectedOrganizationId'])) {
        return newState
          .setIn(['users', 'selectedOrganizationId'], organizations[0].id)
          .setIn(['users', 'selectedOrganizationName'], organizations[0].name)
      }
      return newState
    case getIdentityProgress.success.toString(): {
      const {
        data: { organization },
      } = payload
      return state
        .mergeDeepIn(['all', organization.id.toString()], organization)
        .set('view', organization.id.toString())
    }
    case fetchIdRequest.toString(): {
      const id = get(payload, 'request.data.id', false)
      return state.setIn(['all', id.toString(), 'loaded'], false).setIn(['isPending', 'getOrganizationById'], true)
    }
    case fetchIdRequest.success.toString(): {
      const { data } = payload
      const proTracksLevels = data.proTracksLevels
      let usedLevelsIds = List()
      let hasActiveUsersLevelsIds = List()
      if (proTracksLevels && proTracksLevels.length) {
        usedLevelsIds = proTracksLevels.reduce((prev: any, current: any) => {
          return current.isUsed ? prev.push(current.id) : prev
        }, List())
        hasActiveUsersLevelsIds = proTracksLevels.reduce((prev: any, current: any) => {
          return current.hasActiveUsers ? prev.push(current.id) : prev
        }, List())
      }
      const countriesCodes = mapCountriesCodes(data.countriesCodes)
      const organization = {
        ...data,
        countriesCodes: new CountriesCodes(countriesCodes),
        oneSignal: new OneSignal(data.oneSignal),
        loaded: true,
        proTracksLevels,
      }
      return (
        state
          // @ts-ignore
          .setIn(['all', data.id.toString()], new Organization(fromJS(organization)).prepare())
          .set('view', data.id.toString())
          .set('usedLevelsIds', usedLevelsIds)
          .set('hasActiveUsersLevelsIds', hasActiveUsersLevelsIds)
          .setIn(['viewOrganizationSettings', 'entity'], new Organization(payload.data))
          .setIn(['viewOrganizationSettings', 'loaded'], true)
          .setIn(['isPending', 'getOrganizationById'], false)
      )
    }
    case fetchIdRequest.fail.toString(): {
      return state.setIn(['isPending', 'getOrganizationById'], false)
    }
    case types.ORGANIZATIONS_SELECT_PAGE:
      return state.setIn(['pagination', 'current'], payload.page)
    case types.ORGANIZATIONS_SORT_BY:
      return state.setIn(['sort', 'by'], payload.by).setIn(['sort', 'desc'], payload.desc)
    case types.ORGANIZATIONS_FILTER_BY:
      return state.set('filter', payload.by)
    case types.ADMIN_ORGANIZATION_USERS.GET.SUCCESS:
      return state.setIn(
        ['users', 'all'],
        payload.data.reduce((users: Map<string, any>, user: any) => {
          return users.set(user.id.toString(), new User(fromJS(user)))
        }, Map())
      )
    case fetchUsers.toString():
      return state.setIn(['pending', 'getOrganizationUsers'], true)
    case fetchUsers.success.toString():
      return state
        .setIn(
          ['users', 'usersOnPage'],
          payload.data.data.reduce((users: Map<string, any>, user: any) => {
            return users.set(user.id.toString(), new User(fromJS(user)))
          }, Map())
        )
        .setIn(['users', 'pagination', 'current'], +payload.data.pagination.page)
        .setIn(['users', 'pagination', 'count'], payload.data.pagination.count)
        .setIn(['users', 'pagination', 'totalPages'], Math.ceil(payload.data.pagination.count / PER_PAGE))
        .setIn(['pending', 'getOrganizationUsers'], false)
        .setIn(['users', 'cachedTime'], payload.cached ? Math.floor(payload.cached / 60) : 0)
        .setIn(['users', 'isUsersTeamCanBeRemoved'], payload.data.isUsersTeamCanBeRemoved)
    case fetchUsers.fail.toString():
      return state.setIn(['pending', 'getOrganizationUsers'], false)
    case fetchUsersByStatus.success.toString():
      return state.setIn(['users', 'countByStatus'], payload.data)
    case types.ORGANIZATIONS_USERS_SELECT_PAGE:
      return state.setIn(['users', 'pagination', 'current'], payload.page)
    case types.ORGANIZATIONS_USERS_SORT_BY:
      return state.setIn(['users', 'sort', 'by'], payload.by).setIn(['users', 'sort', 'desc'], payload.desc)
    case types.ORGANIZATIONS_USERS_FILTER_BY:
      return state.setIn(['users', 'filter'], payload.by).setIn(['users', 'pagination', 'current'], 0)
    case types.ORGANIZATIONS_USERS_FILTER_BY_TEAM:
      return state.setIn(['users', 'filterByTeam'], payload.team)
    case types.ORGANIZATIONS_USERS_SWITCH_TAB:
      return state.setIn(['users', 'tab'], payload.tab)
    case types.ORGANIZATIONS_SELECT_USERS_ORGANIZATION:
      return state
        .setIn(['users', 'selectedOrganizationId'], payload.id)
        .setIn(['users', 'selectedOrganizationName'], payload.name)
        .setIn(['users', 'pagination', 'current'], 0)
        .setIn(['users', 'tab'], 'users')
        .setIn(['users', 'filterForAdmin'], '')
    case types.ORGANIZATIONS_FORM_SET_FORM_TYPE: {
      return state.setIn(['form', 'type'], payload.type)
    }
    case types.ORGANIZATIONS_FORM_ENABLE: {
      return state.setIn(['form', 'disabled'], false)
    }
    case types.ORGANIZATIONS_FORM_DISABLE: {
      return state.setIn(['form', 'disabled'], true)
    }
    case types.ORGANIZATIONS_USERS_SELECT_FIRST_ORGANIZATION: {
      if (state.get('all').size >= 1) {
        return state
          .setIn(['users', 'selectedOrganizationId'], state.get('all').first().get('id'))
          .setIn(['users', 'selectedOrganizationName'], state.get('all').first().get('name'))
      }
      return state
    }
    case types.ADMIN_ORGANIZATION_USERS.POST.SUCCESS: {
      return state.mergeDeepIn(
        ['users', 'usersOnPage'],
        get(payload, 'data.data.users', []).reduce((users: Map<string, any>, user: any) => {
          return users.set(user.id.toString(), new User(fromJS(user)))
        }, Map())
      )
    }
    case deleteOrganizationUser.success.toString(): {
      const id = payload.data.id.toString()
      if (isUserOnPageExist(state, id)) {
        return state.deleteIn(['users', 'usersOnPage', id])
      }
      return state
    }
    case types.ADMIN_ORGANIZATION_USERS_RESEND_INVITE.POST.REQUEST: {
      if (!payload.data.id) {
        return state
      }
      const id = payload.data.id.toString()
      if (isUserOnPageExist(state, id)) {
        return state.setIn(['users', 'usersOnPage', id, 'resendInvitePending'], true)
      }
      return state
    }
    case types.ADMIN_ORGANIZATION_USERS_RESEND_INVITE.POST.FAIL: {
      const id = payload.error.toString()
      if (isUserOnPageExist(state, id)) {
        return state.setIn(['users', 'usersOnPage', id, 'resendInvitePending'], false)
      }
      return state
    }
    case types.ADMIN_ORGANIZATION_USERS_RESEND_INVITE.POST.SUCCESS: {
      const id = payload.data.toString()
      if (isUserOnPageExist(state, id)) {
        return state
          .setIn(['users', 'usersOnPage', id, 'resendInvitePending'], false)
          .setIn(['users', 'usersOnPage', id, 'invitationHasBeenSent'], true)
      }
      return state
    }
    case types.ORGANIZATION_SET_PENDING_GET_ORGANIZATION_USERS: {
      return state.setIn(['pending', 'getOrganizationUsers'], payload.pending)
    }
    case types.ORGANIZATIONS_SET_PENDING_OBJECT: {
      return state.set('pendingObject', payload)
    }
    case createOneSignalApplication.success.toString(): {
      return state.setIn(['all', payload.organizationId.toString(), 'oneSignal'], new OneSignal(payload))
    }
    case getUserProtracks.toString(): {
      return state.setIn(['users', 'pending'], true).setIn(['users', 'loaded'], false)
    }
    case getUserProtracks.success.toString(): {
      return state
        .setIn(['users', 'user', 'view'], payload.data.userId)
        .setIn(['users', 'user', 'protracks'], fromJS(payload.data.protracks))
        .setIn(['users', 'user', 'resendNotificationStatus'], fromJS(payload.data.resendNotifications))
        .setIn(['users', 'pending'], false)
        .setIn(['users', 'loaded'], true)
    }
    case getUserProtracks.fail.toString(): {
      return state.setIn(['users', 'pending'], false).setIn(['users', 'loaded'], false)
    }
    case getUserProtrackActivities.success.toString(): {
      return state
        .setIn(['users', 'user', 'activities'], fromJS(payload.data.activities))
        .setIn(['users', 'user', 'publicProTrackName'], payload.data.publicProTrackName)
        .setIn(['users', 'user', 'levelName'], payload.data.levelName)
        .setIn(['users', 'user', 'proTrackLevelId'], payload.data.userProTrackLevelId)
        .setIn(['users', 'user', 'id'], payload.data.userId)
        .setIn(['users', 'user', 'changes'], payload.data.changes)
    }
    case updateUserProtrackActivity.success.toString(): {
      const { activityId, actionType, lastOverride } = payload.data
      const index = state
        .getIn(['users', 'user', 'activities'])
        .findIndex((el: any) => el.get('userActivityId') === activityId)
      return state
        .setIn(['users', 'user', 'activities', index, 'actionType'], actionType)
        .setIn(['users', 'user', 'activities', index, 'lastOverride'], fromJS(lastOverride))
    }
    case setOrganizationUsersFilter.toString(): {
      return state.setIn(['users', 'usersFilter'], payload.value)
    }
    case updateUserPhoneNumber.success.toString(): {
      const { id, phone, phoneISO } = payload
      if (isUserOnPageExist(state, id)) {
        return state
          .setIn(['users', 'usersOnPage', id.toString(), 'phone'], phone)
          .setIn(['users', 'usersOnPage', id.toString(), 'phoneISO'], phoneISO)
      }
      return state
    }
    case updateUserEmail.success.toString(): {
      const { id, email } = payload
      if (isUserOnPageExist(state, id)) {
        return state.setIn(['users', 'usersOnPage', id.toString(), 'email'], email)
      }
      return state
    }
    case updateUserEmailForReviews.success.toString(): {
      const { id, email } = payload
      return state.setIn(['users', 'all', id.toString(), 'email'], email)
    }
    case updateUserTeams.toString(): {
      return state.set('pendingObject', payload.request.pendingObject)
    }
    case updateOrganizationProtrackLevelTeams.toString(): {
      return state.set('pendingObject', payload.request.pendingObject)
    }
    case updateOrganizationProtrackLevelTeamsSuccessForMicroactions.toString(): {
      const {
        newTeams,
        organizationId,
        organizationTeams,
        proTrackLevelId,
        teams,
        isOrganizationProTrackLevelActive,
        customProTrackLevelName,
        level,
      } = payload
      const proTrackLevelIndex = state
        .getIn(['all', organizationId.toString(), 'proTracksLevels'])
        .findIndex((proTrackLevel: any) => {
          return proTrackLevel.get('id') === proTrackLevelId
        })
      if (payload.newTeams.length) {
        state = state.setIn(['all', organizationId.toString(), 'teams'], organizationTeams.concat(newTeams))
      }
      if (proTrackLevelIndex === -1) {
        const organizationProTrackLevels = state.getIn(['all', organizationId.toString(), 'proTracksLevels'])
        const lastLevel1 = level
          .set('id', proTrackLevelId)
          .set('name', customProTrackLevelName)
          .set('hasActiveUsers', false)
          .set('isOrganizationProTrackLevelActive', isOrganizationProTrackLevelActive)
          .set('teams', List(teams))
        return state.setIn(
          ['all', organizationId.toString(), 'proTracksLevels'],
          organizationProTrackLevels.push(lastLevel1)
        )
      }
      return state
        .setIn(['all', organizationId.toString(), 'proTracksLevels', proTrackLevelIndex, 'teams'], teams)
        .setIn(
          [
            'all',
            organizationId.toString(),
            'proTracksLevels',
            proTrackLevelIndex,
            'isOrganizationProTrackLevelActive',
          ],
          isOrganizationProTrackLevelActive
        )
    }
    case updateUserTeamsSuccessForMicroactions.toString(): {
      const { newTeams, organizationId, organizationTeams, userId, teams } = payload
      if (isUserOnPageExist(state, userId)) {
        if (payload.newTeams.length) {
          return state
            .setIn(['all', organizationId.toString(), 'teams'], organizationTeams.concat(newTeams))
            .setIn(['users', 'usersOnPage', userId.toString(), 'teams'], teams)
        } else {
          return state.setIn(['users', 'usersOnPage', userId.toString(), 'teams'], teams)
        }
      }
      return state
    }
    case fetchOrganizationTeams.success.toString(): {
      const { data: teams, organizationId } = payload
      return state.setIn(['all', organizationId.toString(), 'teams'], List(teams))
    }
    case updateUserTeamsSuccessForReviews.toString(): {
      const { newTeams, organizationId, organizationTeams } = payload
      if (payload.newTeams.length) {
        return state.setIn(['all', organizationId.toString(), 'teams'], organizationTeams.concat(newTeams))
      }
      return state
    }
    case fetchOrganizationById.success.toString(): {
      const { data } = payload
      data.countriesCodes = mapCountriesCodes(data.countriesCodes)
      return (
        state
          // @ts-ignore
          .setIn(['invites', 'organization'], new Organization(fromJS(data)))
          // @ts-ignore
          .setIn(['all', data.id.toString()], new Organization(fromJS(data)))
          .setIn(['users', 'selectedOrganizationId'], data.id)
          .setIn(['users', 'selectedOrganizationName'], data.name)
      )
    }
    case updateUserNotificationTypes.toString(): {
      return state.set('pendingObject', fromJS(payload.request.pendingObject))
    }
    case updateUserNotificationTypes.success.toString(): {
      const pendingObject = state.get('pendingObject')
      const id = pendingObject.get('userId')
      if (isUserOnPageExist(state, id)) {
        return state.setIn(
          ['users', 'usersOnPage', id.toString(), 'notificationType'],
          pendingObject.get('notificationTypes')
        )
      }
      return state
    }
    case setReviewsSurveyId.toString(): {
      return state.set('pendingObject', payload.helper)
    }
    case setReviewsSurveyId.success.toString(): {
      const pendingObject = state.get('pendingObject')
      return state.setIn(
        ['all', pendingObject.organizationId.toString(), 'reviewsSurveyId'],
        pendingObject.reviewsSurveyId
      )
    }
    case setApiKeyAndEmailFrom.success.toString():
    case updateApiKeyAndEmailFrom.success.toString(): {
      const { data } = payload
      return state
        .setIn(['all', data.id.toString(), 'emailFrom'], data.emailFrom)
        .setIn(['all', data.id.toString(), 'emailProviderApiKey'], data.emailProviderApiKey)
        .setIn(['all', data.id.toString(), 'isApiKeyEnabled'], data.isApiKeyEnabled)
        .setIn(['all', data.id.toString(), 'displayName'], data.displayName)
    }
    case updateOrganization.success.toString(): {
      const {
        data: { id, countriesCodes },
      } = payload
      return state.setIn(['all', id.toString(), 'countriesCodes'], mapCountriesCodes(countriesCodes))
    }
    case toggleOrganizationSprints.success.toString(): {
      const {
        data: { id, isSprintsActive },
      } = payload
      return state.setIn(['all', id.toString(), 'isSprintsActive'], isSprintsActive)
    }
    case fetchAvailableProTrackLevelsForSelectedOrg.toString(): {
      return state.setIn(['users', 'selectedOrganization', 'proTrackLevels'], List())
    }
    case fetchAvailableProTrackLevelsForSelectedOrg.success.toString(): {
      const { data } = payload
      const filteredData = data.filter(
        ({ isOrganizationProTrackLevelActive }: { isOrganizationProTrackLevelActive: boolean }) => {
          return isOrganizationProTrackLevelActive
        }
      )
      return state.setIn(['users', 'selectedOrganization', 'proTrackLevels'], List(filteredData))
    }
    case fetchSwitchProTrackLevelsHistory.success.toString(): {
      const { data } = payload
      return state.setIn(['users', 'selectedOrganization', 'historySwitchProTrackLevels'], List(data))
    }
    case fetchSwitchProTrackLevelsHistory.fail.toString(): {
      return state.setIn(['users', 'selectedOrganization', 'historySwitchProTrackLevels'], List())
    }
    case fetchOrganizationProtrackLevelChanges.success.toString(): {
      const {
        data: { organizationId, levelsChanges },
      } = payload
      return state.setIn(['all', organizationId.toString(), 'levelsChanges'], fromJS(levelsChanges))
    }
    case postPartnersLinks.success.toString(): {
      const {
        data: { organizationId, partnersLinks },
      } = payload
      return state.setIn(['all', organizationId.toString(), 'partnersLinks'], fromJS(partnersLinks))
    }
    case fetchSprintById.toString(): {
      return state.setIn(['isPending', 'sprint'], true)
    }
    case fetchSprintById.success.toString():
      const { data: sprintData } = payload
      return state
        .setIn(['all', sprintData.organizationId.toString(), 'sprint'], sprintData)
        .setIn(['isPending', 'sprint'], false)
    case fetchSprintById.fail.toString(): {
      return state.setIn(['isPending', 'sprint'], false)
    }
    case deleteSprintById.toString(): {
      return state.set('pendingObject', fromJS(payload.request.pendingObject))
    }
    case deleteSprintById.success.toString(): {
      const pendingObject = state.get('pendingObject')
      const index = state.getIn(['all', pendingObject.get('organizationId'), 'sprints']).findIndex((sprint: any) => {
        return sprint.get('id') === pendingObject.get('sprintId')
      })
      return state.deleteIn(['all', pendingObject.get('organizationId'), 'sprints', index])
    }
    case fetchAllOrganizationUsers.success.toString():
      return state
        .setIn(
          ['users', 'all'],
          payload.data.reduce((users: Map<string, any>, user: any) => {
            return users.set(user.id.toString(), new User(fromJS(user)))
          }, Map())
        )
        .setIn(['users', 'pending'], false)
    case fetchAllOrganizationUsers.fail.toString():
      return state.setIn(['users', 'pending'], false)
    case filterUsersByForAdmin.toString():
      return state.setIn(['users', 'filterForAdmin'], payload)
    case fetchAllOrganizationUsers.toString():
      return state.setIn(['users', 'all'], Map()).setIn(['users', 'pending'], true)
    case deleteOrganizationUserRole.success.toString(): {
      const { userId } = payload.data
      if (isUserOnPageExist(state, userId)) {
        return state.deleteIn(['users', 'usersOnPage', userId.toString()])
      }
      return state
    }
    case deleteOrganizationUserBulkForMicroactionTable.toString(): {
      const { userIds } = payload.request.data
      if (isUserOnPageExist(state, userIds[0])) {
        return state.deleteIn(['users', 'usersOnPage', userIds[0].toString()])
      }
      return state
    }
    case createOrganization.success.toString(): {
      const { data } = payload
      data.countriesCodes = mapCountriesCodes(data.countriesCodes)
      return (
        state
          // @ts-ignore
          .setIn(['invites', 'organization'], new Organization(fromJS(data)))
          // @ts-ignore
          .setIn(['all', data.id.toString()], new Organization(fromJS(data)))
          .setIn(['users', 'selectedOrganizationId'], data.id)
          .setIn(['users', 'selectedOrganizationName'], data.name)
      )
    }
    case getProTrackOrganizationUsersEmails.toString(): {
      return state.set('microActionLevelUsersList', [])
    }
    case getProTrackOrganizationUsersEmails.success.toString(): {
      const { data } = payload
      return state.set('microActionLevelUsersList', data)
    }
    case deleteOrganization.success.toString(): {
      const { data: removedOrganizationId } = payload
      const updatedOrganizations = state.get('all').delete(`${removedOrganizationId}`)
      const firstOrganization = state.get('all').first()
      return state
        .set('all', updatedOrganizations)
        .setIn(['users', 'selectedOrganizationId'], firstOrganization.get('id'))
        .setIn(['users', 'selectedOrganizationName'], firstOrganization.get('name'))
        .setIn(['users', 'pagination', 'current'], 0)
        .setIn(['users', 'tab'], 'users')
        .setIn(['users', 'filterForAdmin'], '')
    }
    case switchOrganizationsUsersSuccess.toString(): {
      const path = ['users', 'selectedOrganization', 'historySwitchProTrackLevels']
      const list = state.getIn(path)
      return state.setIn(path, list.unshift({ isPending: true }))
    }

    case fetchUsersForCSV.toString():
      return state.setIn(['pending', 'getOrganizationUsers'], true)
    case fetchUsersForCSV.success.toString(): {
      exportUsersAsCSV(payload.data.data)
      return state
    }
    case fetchUsersForCSV.fail.toString():
      return state.setIn(['pending', 'getOrganizationUsers'], false)
    case clearCacheOrganizationUsers.success.toString():
      location.reload()
      return state
    default:
      return state
  }
}
